import {css, view, rawCss} from '@sail/ui/deprecated';
import {ChatBubble} from './ChatBubble';
import {ChatRow} from './ChatRow';
import {dotComColors} from '../../theme';

type Props = {
  position?: 'start' | 'end';
  background?: 'neutral100' | 'neutral600';
};

const typingRowCircleStyles = css({
  animationDuration: css.value('1000ms'),
  animationTimingFunction: css.value('cubic-bezier(0, 0.7, 1, 0.3)'),
  animationIterationCount: css.value('infinite'),
});

const typingAnimations = rawCss`
    @keyframes typing-bubble-1 {
      0% {
        transform: translate3d(0, 0, 0);
      }

      12.5% {
        transform: translate3d(0, -4px, 0);
      }

      25% {
        transform: translate3d(0, 0, 0);
      }
    }

    @keyframes typing-bubble-2 {
      0% {
        transform: translate3d(0, 0, 0);
      }

      12.5% {
        transform: translate3d(0, 0, 0);
      }

      25% {
        transform: translate3d(0, -4px, 0);
      }

      37.5% {
        transform: translate3d(0, 0, 0);
      }
    }

    @keyframes typing-bubble-3 {
      0% {
        transform: translate3d(0, 0, 0);
      }

      25% {
        transform: translate3d(0, 0, 0);
      }

      37.5% {
        transform: translate3d(0, -4px, 0);
      }

      50% {
        transform: translate3d(0, 0, 0);
      }
    }
`;

export const TypingRowDotCom = ({
  position,
  background = 'neutral100',
}: Props) => {
  return (
    <view.div data-testid="typing-row">
      <ChatRow position={position}>
        <ChatBubble background={background}>
          <view.span
            uses={[typingAnimations]}
            css={{
              // constraining the dimensions to 16px
              // the viewbox within the svg will ensure the
              // dimensions are accurate within that constraint (16x4)
              maxWidth: css.value('16px'),
              // the 100% height will ensure this span container
              // fills the default height of the ChatBubble,
              // allowing us to center the svc vertically
              height: css.value('100%'),
              // center the svg within the span
              marginX: 'xsmall',
              marginY: 'small',
              stack: 'y',
              align: 'center',
            }}
          >
            <view.svg
              // scale the svg to fill the span container
              width="100%"
              height="100%"
              // constrain the svg to 16x4 relative to the scaled dimensions
              viewBox="0 0 16 4"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              css={{overflow: css.value('visible')}}
            >
              <view.circle
                data-testid="typing-row-circle"
                uses={[typingRowCircleStyles]}
                cx={2}
                cy={2}
                r={2}
                fill={dotComColors.brand600}
                opacity={0.4}
                css={{
                  animationName: css.value('typing-bubble-1'),
                }}
              />
              <view.circle
                data-testid="typing-row-circle"
                uses={[typingRowCircleStyles]}
                cx={8}
                cy={2}
                r={2}
                fill={dotComColors.brand600}
                opacity={0.4}
                css={{
                  animationName: css.value('typing-bubble-2'),
                }}
              />
              <view.circle
                data-testid="typing-row-circle"
                uses={[typingRowCircleStyles]}
                cx={14}
                cy={2}
                r={2}
                fill={dotComColors.brand600}
                opacity={0.4}
                css={{
                  animationName: css.value('typing-bubble-3'),
                }}
              />
            </view.svg>
          </view.span>
        </ChatBubble>
      </ChatRow>
    </view.div>
  );
};
